package nl.astraeus.wiki.messages

import nl.astraeus.wiki.domain.WikiListDto

class WikiMessage() : Message(
  MessageType.WIKI_MESSAGE,
  MessageHeader.WIKI_ID,
  MessageHeader.WIKI_TITLE,
) {

  constructor(msg: String) : this() {
    message = msg
  }

  constructor(msgId: String, wiki: WikiListDto, body: String) : this() {
    setHeader(MessageHeader.MESSAGE_ID, msgId)
    setHeader(MessageHeader.WIKI_ID, wiki.id.toString())
    setHeader(MessageHeader.WIKI_TITLE, wiki.title)

    setBody(body)
  }

}
